/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Destek_KanallarInputs */

const tr_faq_a_destek_kanallar = /** @type {(inputs: Faq_A_Destek_KanallarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulama içindeki Yardım sayfasından sohbet desteğine ulaşabilirsin. Ayrıca destek@emonse.com adresine e-posta atabilir ya da Telegram destek kanalımıza katılabilirsin. Acil teknik sorunlar için Telegram en hızlı yanıt kanalıdır.`)
};

const en_faq_a_destek_kanallar = /** @type {(inputs: Faq_A_Destek_KanallarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the chat on the Help page inside the app. You can also email destek@emonse.com or join our Telegram support channel. For urgent technical issues Telegram is the fastest channel.`)
};

const de_faq_a_destek_kanallar = /** @type {(inputs: Faq_A_Destek_KanallarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutze den Chat auf der Hilfe-Seite in der App. Du kannst auch an destek@emonse.com schreiben oder unserem Telegram-Supportkanal beitreten. Bei dringenden technischen Problemen ist Telegram am schnellsten.`)
};

const ru_faq_a_destek_kanallar = /** @type {(inputs: Faq_A_Destek_KanallarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Воспользуйтесь чатом на странице Помощь в приложении. Также можно написать на destek@emonse.com или вступить в наш Telegram-канал поддержки. По срочным техническим вопросам Telegram отвечает быстрее всего.`)
};

/**
* | output |
* | --- |
* | "Use the chat on the Help page inside the app. You can also email destek@emonse.com or join our Telegram support channel. For urgent technical issues Telegram..." |
*
* @param {Faq_A_Destek_KanallarInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_destek_kanallar = /** @type {((inputs?: Faq_A_Destek_KanallarInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Destek_KanallarInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_destek_kanallar(inputs)
	if (locale === "de") return de_faq_a_destek_kanallar(inputs)
	if (locale === "ru") return ru_faq_a_destek_kanallar(inputs)
	return tr_faq_a_destek_kanallar(inputs)
});